import React from "react";

const Loading = () => (
  <div style={{display:"flex", justifyContent:"center", alignItems:"center", height:"100vh"}}>
    <img src="/images/loading.gif" width="100px" height="100px"/>
  </div>
)

export default Loading;